import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DashboardPage, DeclarationDashboardStatsDTO, DeclarationListItemDTO } from '../models/dashboard.models';

@Injectable({ providedIn: 'root' })
export class DeclarationsDashboardApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiURL}/master-data/api/v1/declarations_v2`;

  getDashboardStats(
    organizationId: string | null,
    startDate: string | null,
    endDate: string | null
  ): Observable<DeclarationDashboardStatsDTO> {
    let params = new HttpParams();
    if (organizationId) params = params.set('organizationId', organizationId);
    if (startDate) params = params.set('startDate', startDate);
    if (endDate) params = params.set('endDate', endDate);
    return this.http.get<DeclarationDashboardStatsDTO>(`${this.baseUrl}/dashboard-stats`, { params });
  }

  /** Raw (non-aggregated) recent declarations, for the "Dernières déclarations" table. */
  getRecent(organizationId: string | null, size = 8): Observable<DashboardPage<DeclarationListItemDTO>> {
    let params = new HttpParams().set('page', '0').set('size', String(size));
    if (organizationId) params = params.set('organizationId', organizationId);
    return this.http.get<DashboardPage<DeclarationListItemDTO>>(this.baseUrl, { params });
  }
}
